export class PlanAuthorization {
    public planHeader: string;
    public planDetail: string;
    public planTarget: string;
    public planFinal: string;
    public countryManagerEndorsement: string;
    public productConfirmation: string;
    public attachmentUpload: boolean;
    public saveAllowed: boolean;
    public nextAllowed: boolean;
    public refuseAllowed: boolean;

    constructor(
        planHeader?: string,
        planDetail?: string,
        planTarget?: string,
        planFinal?: string,
        countryManagerEndorsement?: string,
        productConfirmation?: string,
        attachmentUpload?: boolean,
        saveAllowed?: boolean,
        nextAllowed?: boolean,
        refuseAllowed?: boolean
    ) {
        this.planHeader = planHeader;
        this.planDetail = planDetail;
        this.planTarget = planTarget;
        this.planFinal = planFinal;
        this.countryManagerEndorsement = countryManagerEndorsement;
        this.productConfirmation = productConfirmation;
        this.attachmentUpload = attachmentUpload;
        this.saveAllowed = saveAllowed;
        this.nextAllowed = nextAllowed;
        this.refuseAllowed = refuseAllowed;
    }
}